import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid\" viewBox=\"0 0 16 17\" id=\"search\"><path d=\"m15.757 15.484-3.944-4.208a6.946 6.946 0 0 0 1.569-4.412C13.382 3.079 10.381 0 6.691 0 3.002 0 0 3.079 0 6.864c0 3.784 3.002 6.863 6.691 6.863a6.505 6.505 0 0 0 3.834-1.242l3.974 4.24a.855.855 0 0 0 1.234.025.914.914 0 0 0 .024-1.266ZM6.691 1.79c2.727 0 4.946 2.276 4.946 5.074 0 2.797-2.219 5.073-4.946 5.073S1.746 9.661 1.746 6.864c0-2.798 2.218-5.074 4.945-5.074Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol